export default __webpack_public_path__ + "static/media/handbookOrderFailed.d750f9b6.png";